import { decimalToOdds, oddsToDecimal, type DisplayOddsFormat } from './odds-format';

/** Input is target profit for negative Malay/Indo, actual risk for other formats. */
export const calculateOddsPayout = (amount: number, value: unknown, format: DisplayOddsFormat) => {
  const decimal = oddsToDecimal(value, 'decimal');
  if (!Number.isSafeInteger(amount) || amount <= 0 || decimal === null) return null;
  const quote = decimalToOdds(decimal, format);
  if (quote === null) return null;
  const inputMode = (format === 'malay' || format === 'indo') && quote < 0 ? 'profit' : 'risk';
  // Derive the full-precision quote from decimal; never calculate from rounded DOM text.
  const risk = inputMode === 'profit' ? Math.round(amount * Math.abs(quote)) : amount;
  const profit = inputMode === 'profit' ? amount : Math.round(amount * (decimal - 1));
  const totalReturn = risk + profit;
  if (![risk, profit, totalReturn].every(Number.isSafeInteger) || risk <= 0 || profit < 0) return null;
  return { inputAmount: amount, inputMode, risk, profit, totalReturn };
};
